// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2_lGc","actionsCol":"EnrolledClinics_actionsCol__2lI0g"};